/**
 * Structured logger for OneTrust consent events.
 *
 * Emits a single canonical shape — `{ source: 'onetrust-consent', event, ...fields }`
 * — so Datadog dashboards can filter on `@source:onetrust-consent` and break
 * down by `@event`.
 *
 * Browser-only — the dispatcher in `wrapper.js` lives in an inline script and
 * can't import this module, so it emits the same shape inline. Keep both in sync.
 */

export type ConsentEventName = 'consentRevoked' | 'handlerError';

export interface ConsentEvent {
  event: ConsentEventName;
  activeGroups?: string[];
  previousActiveGroups?: string[];
  revokedCategories?: string[];
  /** Where in the dispatcher lifecycle a handler error occurred. */
  phase?: 'dispatch' | 'replay';
  /** Error message (extracted from Error to keep Datadog fields flat). */
  message?: string;
  /** Error stack (extracted from Error). */
  stack?: string;
}

const LOG_SOURCE = 'onetrust-consent';

export function logConsentEvent(payload: ConsentEvent): void {
  console.warn({ source: LOG_SOURCE, ...payload });
}
